import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { withDefaults, computed } from 'vue'

import AnimationPushToShadow from '@/components/AnimationPushToShadow/AnimationPushToShadow.vue'

interface Props {
  tag?: string
  color?: string
  shadow?: 'none' | 'xs' | 's' | 'm' | 'l'
  rounded?: string
  outline?: boolean
  disabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppButton',
  props: {
    tag: { default: 'div' },
    color: { default: 'yellow' },
    shadow: { default: 's' },
    rounded: { default: 'pill' },
    outline: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { tag: string, color: string, shadow: 'none' | 'xs' | 's' | 'm' | 'l', rounded: string, outline: boolean, disabled: boolean }

/**
 * AppButton.
 */



const shadowSizes = {
  none: '0px',
  xs: '2px',
  s: '4px',
  m: '8px',
  l: '12px',
}

const className = computed(() => {
  return [
    'appButton',
    props.color,
    props.outline ? 'outline' : '',
    props.disabled ? 'disabled' : '',
  ]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tag), {
    class: _normalizeClass(_unref(className))
  }, {
    default: _withCtx(() => [
      _createVNode(AnimationPushToShadow, {
        shadowX: shadowSizes[__props.shadow],
        shadowY: shadowSizes[__props.shadow],
        rounded: __props.rounded
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["shadowX", "shadowY", "rounded"])
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})